import { RequestCuote, CuoteResponse, ManageQuote, SolutionResponse, WaitingSolution } from "./Components";
import { NoHistorial } from "../../../../../../../../components/errors/noHistorial";
import { useState, useCallback } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Status } from "../../../../../../../../utils/enums";
import { RequestIntruction } from "./Components/requestInstruction";
import { SolutionResponseList } from "./Components/solutionResponseList";
import { ManageQuoteList } from "./Components/manageSolutionOne";

export const HistoryReportFolio = ({ onAttend, historial, left, isLoading, getHistorial, options, setOptions, setCurrentDataSolution, isList, setIsList }) => {
    const [isReloading, setIsReloading] = useState(false);

    const reload = useCallback(async () => {
        if (isReloading) return;
        setIsReloading(true);
        try {
            await getHistorial(!!options[1].check, !!options[2].check);
        } finally {
            setIsReloading(false);
        }
    }, [isReloading, getHistorial]);


    const renderStepItem = useCallback((item) => {
        const commonProps = {
            key: item.id,
            items: [item],
            reload,
            onAttend,
            left,
            list: undefined,
            isMosaico: undefined,
            position: undefined,
            disabled: (left.status.id == Status.NOT_FINISHED || left.status.id == Status.EXPIRED) ? true : false
        };

        const isLista = item.answers.length>1;

        switch (item.newStep) {
            case "MANAGE_QUOTE":
            case "MANAGE_SOLUTION":
                if (isLista) {
                    return <ManageQuoteList {...commonProps} setCurrentDataSolution={setCurrentDataSolution} isList={isList} setIsList={setIsList} />;
                }
                return <ManageQuote {...commonProps} setCurrentDataSolution={setCurrentDataSolution}/>;
                
            case "COMMENT_INSTRUCTON":
                return <RequestIntruction options={options} setOptions={setOptions} {...commonProps} />;
            case "REQUEST_QUOTES":
                return <RequestCuote options={options} setOptions={setOptions} {...commonProps} />;
            case "SOLUTION":
                if (isLista) {
                    return <SolutionResponseList options={options} setOptions={setOptions} {...commonProps} setCurrentDataSolution={setCurrentDataSolution} isList={isList} setIsList={setIsList} />;
                }
                return <SolutionResponse {...commonProps} setCurrentDataSolution={setCurrentDataSolution} options={options} setOptions={setOptions} />;
            case "WAITING":
                return <WaitingSolution {...commonProps} />;
            case "QUOTE":
                return <CuoteResponse {...commonProps} />;
            default:
                return null;
        }
    }, [reload, onAttend]);

    if (isLoading || isReloading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            {historial?.items?.length > 0 ? (
                <Box sx={{ width: '100%' }}>
                    {historial.items.map(renderStepItem)}
                </Box>
            ) : (
                <NoHistorial
                    label="No hay historial disponible"
                    footer="Contacta al encargado"
                />
            )}
        </Box>
    );
};